'use client';

import * as React from 'react';
import Image from 'next/image';

import { BlurFade } from '~/components/fragments/blur-fade';
import { GridSection } from '~/components/fragments/grid-section';
import { cn } from '@workspace/ui/lib/utils';

const DATA = [
  { icon: '/assets/logos/nature-re.png', alt: 'NatureRe' },
  { icon: '/assets/logos/radix-florestal.webp', alt: 'Radix Florestal', className: 'p-1 bg-gray-700 bg-[#183c18] dark:bg-unset' },
];

export function Logos(): React.JSX.Element {
  return (
    <GridSection className="bg-diagonal-lines">
      <div className="flex flex-col items-center justify-between gap-2 bg-background p-8 sm:flex-row sm:py-4">
        <BlurFade className="mb-6 sm:mb-0">
          <p className="max-w-[220px] text-center text-sm text-muted-foreground sm:text-left">
            Trusted by leading conservation companies around the world
          </p>
        </BlurFade>
        <div className="grid grid-cols-2 gap-6 md:grid-cols-4 lg:max-w-4xl lg:gap-10">
          {DATA.map(({ icon: Icon, alt, className }, index) => (
            <BlurFade
              key={index}
              delay={0.2 + index * 0.2}
              className={cn("flex items-center justify-center text-neutral-700 dark:text-neutral-300", className)}
            >
              <Image
                src={Icon}
                alt={alt}
                width={150}
                height={150}
              />
            </BlurFade>
          ))}
        </div>
      </div>
    </GridSection>
  );
}
